import { Navigate, Route, Routes } from "react-router-dom";
import { Login } from "@/pages/Login/Login";
import { Dashboard } from "@/pages/Dashboard/Dashboard";
import { Subjects } from "@/pages/Subjects/Subjects";
import { Lessons } from "@/pages/Lessons/Lessons";
import { LessonDetails } from "@/pages/LessonDetails/LessonDetails";
import { Player } from "@/pages/Player/Player";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/subjects/:subjectId" element={<Subjects />} />
      <Route path="/lessons" element={<Lessons />} />
      <Route path="/lessons/:lessonId" element={<LessonDetails />} />
      <Route path="/player/:lessonId" element={<Player />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
